import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { SearchBarComponent } from '../../../../../shared/components/search-bar/search-bar.component';
import { TableModule } from 'primeng/table';
import { Select } from 'primeng/select';
import { DialogService } from 'primeng/dynamicdialog';
import { CadastrarCursoComponent } from '../cadastrar-curso/cadastrar-curso.component';
import { CommonModule } from '@angular/common';
import { Curso, FilterItem } from '../../api/models';
import { niveisAcademicos } from '../../api/models/allEnums';
import { Pagination } from '@app/shared/model';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import {
  TableColumn,
  TableComponent,
} from '@app/shared/components/table/table.component';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AreaFormacaoService,
  AreaProgramaFormacaoService,
  CategoriaInstituicaoEnsinoService,
  CursoService,
  EnumService,
} from '../../api/services';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { MenuModule } from 'primeng/menu';
import { ToastModule } from 'primeng/toast';
import { ApiService } from '@core/providers/http';
import { Dialog } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { mergeMap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import {
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
} from '@angular/forms';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
import { AuthStore } from '@core/service/auth-store.service';

@Component({
  selector: 'app-lista-cursos',
  imports: [
    CommonModule,
    SearchBarComponent,
    TableModule,
    Select,
    TableComponent,
    MenuModule,
    ConfirmDialog,
    ToastModule,
    Dialog,
    ButtonModule,
    InputTextModule,
    CadastrarCursoComponent,
    DataVoidComponent,
    FormsModule,
    ReactiveFormsModule,
    BackButtonComponent,
  ],
  providers: [
    DialogService,
    MessageService,
    ConfirmationService,
    CursoService,
    AreaFormacaoService,
    AreaProgramaFormacaoService,
    CategoriaInstituicaoEnsinoService,
    EnumService,
    ApiService,
  ],
  templateUrl: './lista-cursos.component.html',
  styleUrl: './lista-cursos.component.scss',
  standalone: true,
})
export class ListaCursosComponent implements OnInit {
  private messageService = inject(MessageService);
  private dialogService = inject(DialogService);
  private auth = inject(AuthStore);
  private cursoService = inject(CursoService);
  areaFormacaoService = inject(AreaFormacaoService);
  private categoriaInstituicaoEnsino = inject(
    CategoriaInstituicaoEnsinoService,
  );
  private confirmationService = inject(ConfirmationService);
  private enumService = inject(EnumService);
  areaProgramaFormacaoService = inject(AreaProgramaFormacaoService);
  areaFormacaoList: any[] = [];
  areaProgramaFormacaoList: any[] = [];
  cursoList: any[] = [];
  categoriaInstituicaoEnsinoList: any[] = [];
  nivelAcademicoOptions: any[] = [];
  perfilOptions: any[] = [];
  pagination: Pagination<any> = new Pagination<any>();

  @Output() courseCount: EventEmitter<number> = new EventEmitter<number>();
  isLoading: boolean = false;
  showFilter: boolean = false;
  form!: FormGroup;
  cursoCount: any;

  estadoFormacao: any[] = [
    { label: 'Activo', value: 'activo' },
    { label: 'Inactivo', value: 'inativo' },
  ];

  filters: FilterItem[] = [
    {
      type: 'dropdown',
      controlName: 'curso',
      options: this.cursoList,
      placeholder: 'Nome do curso',
      optionLabel: 'designacao',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'AreaFormacaoID',
      placeholder: 'Área de Formação',
      options: this.areaFormacaoList,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'CategoriaID',
      placeholder: 'Categoria do curso',
      options: this.categoriaInstituicaoEnsinoList,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'nivelAcademico',
      placeholder: 'Nível Académico',
      options: this.nivelAcademicoOptions,
      optionLabel: 'designacao',
      optionValue: 'value',
    },
    {
      type: 'dropdown',
      controlName: 'perfilEstudante',
      placeholder: 'Tipo de Estudante',
      options: this.perfilOptions,
      optionLabel: 'designacao',
      optionValue: 'value',
    },
  ];

  actions: MenuItem[] = [
    {
      label: 'Editar curso',
      icon: 'pi pi-pencil',
      command: (event) => this.editCurso(event.item?.['data']),
    },
    // {
    //   label: 'Detalhes do curso',
    //   icon: 'pi pi-eye',
    //   command: (event) => this.detalheCurso(event.item?.['data']),
    // },
    {
      label: 'Eliminar curso',
      icon: 'pi pi-trash',
      command: (event) => this.toggleStatus(event.item?.['data']),
    },
  ];

  columns: TableColumn[] = [
    { field: 'designacao', header: 'Nome do Curso' },
    { field: 'areaFormacaoDescricao', header: 'Área de Conhecimento' },
    { field: 'categoria', header: 'Categoria' },
    { field: 'nivelAcademico', header: 'Nível Académico' },
  ];

  constructor(public fb: FormBuilder) {}

  ngOnInit(): void {
    this.getCursoLista();
    this.getAllAreaFormacao();
    this.getAllCategoriaInstituicaoEnsino();
    this.loadNivelAcademicoEnum();
    this.loadPerfilEstudanteEnum();
    this.getAllCursos();

    this.form = this.fb.group({
      curso: [null],
      AreaFormacaoID: [null],
      CategoriaID: [null],
      nivelAcademico: [null],
      perfilEstudante: [null],
    });
  }

  getAllCursos(filters?: any) {
    const params = {
      pageNumber: 1,
      pageSize: 100,
      ...filters,
    };
    this.cursoService.list(params).subscribe(
      (res: any) => {
        this.cursoList = res.data;
        this.filters[0].options = this.cursoList;
      },
      (error: any) => {
        console.error('Erro ao buscar cursos:', error);
      },
    );
  }

  getAllAreaFormacao() {
    this.areaFormacaoService.list({ pageSize: 100 }).subscribe((response) => {
      this.areaFormacaoList = response.data;
      this.filters[1].options = this.areaFormacaoList;
    });
  }

  getAllCategoriaInstituicaoEnsino() {
    this.categoriaInstituicaoEnsino
      .list({ pageSize: 100 })
      .subscribe((response) => {
        this.categoriaInstituicaoEnsinoList = response.data;
        this.filters[2].options = this.categoriaInstituicaoEnsinoList;
      });
  }

  loadNivelAcademicoEnum() {
    this.enumService.getAllNivelAcademicoEnum().subscribe((response) => {
      if (response?.data) {
        this.nivelAcademicoOptions = Object.entries(response.data).map(
          ([key, value]) => ({
            id: Number(key),
            designacao: value,
          }),
        );
        this.filters[3].options = this.nivelAcademicoOptions;
      }
    });
  }

  loadPerfilEstudanteEnum() {
    this.enumService.getAllEnumPerfilEstudanteEnum().subscribe((response) => {
      if (response?.data) {
        this.perfilOptions = Object.entries(response.data).map(
          ([key, value]) => ({
            id: Number(key),
            designacao: value,
          }),
        );
        this.filters[4].options = this.perfilOptions;
      }
    });
  }

  getCursoLista(filters?: any) {
    this.isLoading = true;
    const params = {
      ...filters,
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 10,
      orderBy: filters?.orderBy || 'id desc',
    };

    this.cursoService.list(params).subscribe({
      next: (result: any) => {
        this.pagination = new Pagination<any>().deserialize(result);
        this.courseCount.emit(this.pagination?.data?.length);
        this.cursoCount = this.pagination?.totalRecords;
      },
      error: (error: any) => {
        console.error('Erro ao buscar cursos:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao buscar cursos.',
        });
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  detalheCurso(curso: Curso) {
    // Implementar lógica para exibir detalhes do curso
  }

  // deleteCurso(curso: Curso) {
  //   this.confirmationService.confirm({
  //     message: `Tem certeza que deseja eliminar o curso "${curso.designacao}"?`,
  //     accept: () => {
  //       this.cursoService.delete(curso.id).subscribe(() => {
  //         this.getCursoLista();
  //         this.messageService.add({
  //           severity: 'success',
  //           summary: 'Sucesso',
  //           detail: 'Curso eliminado com sucesso!',
  //           life: 3000,
  //         });
  //       });
  //     },
  //   });
  // }

  toggleStatus(curso: Curso) {
    this.confirmationService.confirm({
      message: `Tem certeza que deseja eliminar o curso "${curso.designacao}"?`,
      accept: () => {
        this.cursoService.toggleStatus(curso.id).subscribe(() => {
          this.getCursoLista();
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Curso eliminado com sucesso!',
            life: 3000,
          });
          console.log('Curso desativado com sucesso!');
        });
      },
    });
  }

  handleFormValueChange(event: any) {
    const filters = Object.fromEntries(
      Object.entries(event).filter(
        ([_, value]) => value !== null && value !== undefined && value !== '',
      ),
    );
    console.log('Filtered values:', filters);
    this.getCursoLista(filters);
    this.showFilter = false;
  }

  onActionSelected(event: { event: any; rowData: Curso }) {
    const action = event.event.value;
    const curso = event.rowData;
    if (action === 'edit') {
      this.editCurso(curso);
    } else if (action === 'delete') {
      this.toggleStatus(curso);
    }
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.getCursoLista();
  }
  editCurso(curso: Curso) {
    if (this.auth.hasAny(['actualizar_cursos'])) {
      this.openCursoDialog(curso, 'Editar Curso', '50%');
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Permissão Inválida',
        detail: 'Não tens permissão para efetuar esta acção',
        life: 3000,
      });
    }
  }

  showFilterModal() {
    this.showFilter = true;
  }

  showDialog() {
    if (this.auth.hasAny(['registar_cursos'])) {
      this.openCursoDialog(null, null, '40%');
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Permissão Inválida',
        detail: 'Não tens permissão para efetuar esta acção',
        life: 3000,
      });
    }
  }

  openCursoDialog(curso: Curso | null, header: any | null, width: string) {
    const ref = this.dialogService.open(CadastrarCursoComponent, {
      data: {
        cursoDetails: curso,
        areaFormacaoList: this.areaFormacaoList,
        categoriaInstituicaoEnsinoList: this.categoriaInstituicaoEnsinoList,
        nivelAcademicoOptions: this.nivelAcademicoOptions,
      },
      header: header,
      showHeader: false,
      width: width,
      modal: true,
    });

    ref.onClose
      .pipe(
        mergeMap((data) => {
          if (data) {
            this.isLoading = true; // Iniciar carregamento
            return curso && curso.id
              ? this.cursoService.update(data)
              : this.cursoService.store(data);
          }
          return EMPTY; // Retornar um observable vazio se não houver dados
        }),
      )
      .subscribe({
        next: (response) => {
          this.isLoading = false; // Parar carregamento
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: curso
              ? 'Curso actualizado com sucesso!'
              : 'Curso cadastrado com sucesso!',
            life: 3000,
          });
          this.getCursoLista();
        },
        error: (err) => {
          this.isLoading = false; // Parar carregamento
          console.error('Erro ao salvar Curso:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Erro ao salvar Curso.',
            life: 3000,
          });
        },
      });
  }
}
